import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getAllActiveBusesForLane } from "components/Apis/Buses";

export const fetchActiveBusesForLane = createAsyncThunk(
    'filter/fetchActiveBuses',
    async (lane = 0, { rejectWithValue }) => {
        try {
            const response = await getAllActiveBusesForLane(lane);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const activeBusessSlice = createSlice({
    name: 'actveBuses',
    initialState: {
        data: {
            buses: [],
            partialable_orders: [],
        },
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchActiveBusesForLane.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchActiveBusesForLane.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload; // Store the list of people
            })
            .addCase(fetchActiveBusesForLane.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
    },
});

export default activeBusessSlice.reducer;